export const emptyObject = obj => Object.keys(obj).forEach(key => delete obj[key])

export const titleCase = (str) => {
  if (!str) return ''
  const result = str.replace(/([A-Z])/g, ' $1')
  return result.charAt(0).toUpperCase() + result.slice(1)
}
